import { LayoutBox } from '../../components';
import { Box, GridModal, Text } from '../../ui';

const ReverseMCEModal = ({ showModal, setShowModal, loading, disabled, handlePress }) => {
  return (
    <GridModal
      title="Reverse MCE"
      buttonText="Reverse"
      handlePress={handlePress}
      open={showModal}
      onClose={() => {
        setShowModal(false);
      }}
      width="480px"
      capitalizeTitle={true}
      disabled={disabled}
      loading={loading}
    >
      <LayoutBox gap={16} padding="16px">
        <Box style={{ color: '#212B36', fontWeight: '500', fontSize: '14px', textAlign: 'start' }} alignItems="flex-start">
          <Text value="Please confirm that you want to reverse this MCE." bold></Text>
        </Box>
        <Box style={{ color: '#637381', fontWeight: '500', fontSize: '14px', textAlign: 'start' }} alignItems="flex-start">
          <Text value="This will create an equal but opposite MCE (in terms of premium) to effectively undo the reversed MCE." bold></Text>
        </Box>
      </LayoutBox>
    </GridModal>
  );
};

export default ReverseMCEModal;
